<script setup lang="ts">
import {ELO_LOCALES, setLocale} from "../ts/translations";
import {computed, watch} from "vue";

const props = defineProps(['ui_locales']);
const result_ui_locales = computed(() => {
  if (!props.ui_locales) {
    return ELO_LOCALES;
  }
  return props.ui_locales;
});

const selectedLocale = defineModel<string>()

watch(selectedLocale, async (newVal) => {
  console.log('selectedLocale', newVal);
  await setLocale(newVal);
});

// EAUTH-213: sorted locale labels
const localeLabels = {
  "id": "Bahasa Indonesia",
  "cs": "Česky",
  "da": "Dansk",
  "de": "Deutsch",
  "el": "Ελληνικά",
  "en": "English",
  "es": "Español",
  "es-419": "Español (Latinoamericano)",
  "fr": "Français",
  "it": "Italiano",
  "hu": "Magyar",
  "nl": "Nederlands",
  "pl": "Polski",
  "pt": "Português",
  "pt-BR": "Português (Brasil)",
  "ro": "Română",
  "sk": "Slovensky",
  "sr": "Srpski",
  "sr-Cyrl": "\u0441\u0440\u043F\u0441\u043A\u0438",
  "fi": "Suomi",
  "tr": "Türkçe",
  // EAUTH2-140: Support zh-CN
  "zh-CN": "\u4e2d\u6587"
}
</script>

<template>
  <b-dropdown
      class="locale-selector-dropdown"
      scrollable
      :max-height="300"
      position="is-bottom-left"
      v-model="selectedLocale"
      aria-role="locale-selector">
    <template #trigger>
      <b-button data-test-id="locale-selector"
          class="locale-selector-button"
          :label="'🌐 ' + localeLabels[selectedLocale]"
          type="is-secondary"
          icon-pack="e-icon"
          icon-right="angle-down" />
    </template>

    <template v-for="locale in result_ui_locales">
      <b-dropdown-item :value="locale" aria-role="listitem" :data-test-id="'locale-' + locale">{{localeLabels[locale]}}</b-dropdown-item>
    </template>
  </b-dropdown>
</template>

<style>
.dropdown-menu {
  border: 1px solid #ccc;
  text-align: left;
}
.locale-selector-button {
  background-color: white; /* See EAUTH2-142 */
}
.locale-selector-dropdown .dropdown-menu {
  padding-top: 0; /* See EAUTH2-142 */
}
</style>
